import React from 'react';
import { Button } from 'rsuite';
import { LiaDownloadSolid } from 'react-icons/lia';
import { GeneratedDocument } from '../../api/generateddocuments/generatedDocumentsApiTypes';

interface Props {
  document: GeneratedDocument;
}

export default function GeneratedDocumentDownloadCell({ document }: Props) {
  const disabled = !document.url;

  function handleDownload() {
    if (document.url) {
      window.open(document.url);
    }
  }

  return (
    <Button
      size="sm"
      disabled={disabled}
      onClick={() => handleDownload()}
    >
      <LiaDownloadSolid />
    </Button>
  );
}
